import jQuery from "jquery";
window.jQuery = jQuery;



// WEBPACK FOOTER //
// ./src/include/jQuery.js